/**
 * Material imports
 */

import ErrorIcon from '@mui/icons-material/Error'

/**
 * Relative exports to root directory"editor.codeActionsOnSave": {
  "source.organizeImports": true
}
 */
import { Box, Paper } from '@mui/material'
import { useThemeMode } from '../../../theme'
import { TranslatableTypography } from './Typography'

const getThemeSx = (palette) => ({
  box: {
    width: '100%',
    padding: '5px'
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative'
    // boxShadow: '0px 0px 5px #20181d, 0px 0px 5px #20181d'
  },
  wrapper: {
    padding: '35px',
    textAlign: 'center',
    '& .error-icon': { fontSize: 120, color: palette.headerColor }
  },
  errorIcon: { fontSize: 120, color: palette.headerColor },
  typography: { fontWeight: 600, color: palette.headerColor }
})

export const NoData = (props) => {
  const label = props?.label ?? 'No data available'
  const icon = props?.icon ?? (<ErrorIcon className='error-icon'/>)
  const { palette } = useThemeMode()
  const themeSX = getThemeSx(palette)

  return (
    <Box sx={themeSX.box}>
      <Paper sx={themeSX.container} elevation={3}>
        <Box sx={themeSX.wrapper}>
          {icon}
          <TranslatableTypography sx={themeSX.typography}>
            {label}
          </TranslatableTypography>
        </Box>
      </Paper>
    </Box>
  )
}
